import formatProductsData from './format-products-data-shopify';
import fieldsRequest from './fields-request';
import loadProductsByCollection from '../../core/storefrontAPI/load-products-by-collection';

/*
This fallback class is used to handle Shopify collections in case Nosto data has issues
Important: also update the NostoCollections class in collections.js if editing this one
*/
export default class ShopifyCollection {
  collection_id;
  fields;

  constructor(collection_id) {
    this.collection_id = collection_id;
    this.fields = fieldsRequest;

    window.theme.collections.filtering = [];
    window.theme.collections.sorting = 'manual';
  }

  /**
   * Make Shopify Storefront API request
   * Doesn't apply to search overlay
   *
   * Note: the ambassador tag built into `excludeTags` here, and the combined_product parent exclusion, are both
   * filtered out client-side inside loadProductsByCollection after the response comes back, since the Storefront
   * API's ProductFilter has no negation support (no "not"/tagNot, and no metafield "not equal" field). This means
   * a page can render with fewer than products_per_page items, and cursor-based paging can skip/duplicate
   * boundary items when excluded products fall on a page edge.
   *
   * @returns {Promise} Formatted products data
   */
  shopifyRequest = async () => {
    try {
      const filters = [];

      // Enforce plus size-only products on plus size collections
      if (document.querySelector('[data-collection-grid]')?.dataset?.plus === 'true') {
        filters.push({ variantMetafield: { namespace: 'astr', key: 'plus_size', value: 'true' } });
      }

      // Hide ambassaor products if not on the ambassador collection
      // Hide ambassaor products on the ambassador collection but the user is not an ambassador (in case someone hacks the redirect from the collection page)
      let excludeTags = [];
      if ((window.theme.collections.current === 'ambassador' && !window.theme.customer.ambassador) || window.theme.collections.current !== 'ambassador') {
        excludeTags = ['ambassador'];
      }

      console.log('[ASTR] filters', filters, 'excludeTags', excludeTags);
      console.log('[ASTR] products_per_page: ', window.theme.collections.products_per_page, ' page: ', window.theme.collections.page);

      const response = await loadProductsByCollection(window.theme.collections.current_id, '', filters, excludeTags);

      return formatProductsData(response);
    } catch (error) {
      console.log('ShopifyCollection Error', error);
      return [];
    }
  };
}
